import { render, staticRenderFns } from "./CpaBox.vue?vue&type=template&id=46d54ad5&scoped=true"
import script from "./CpaBox.vue?vue&type=script&lang=js"
export * from "./CpaBox.vue?vue&type=script&lang=js"
import style0 from "./CpaBox.vue?vue&type=style&index=0&id=46d54ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d54ad5",
  null
  
)

export default component.exports